import Layout from "../components/Layout";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  return (
    <Layout>
      <Helmet>
        <title>Page Not Found | RedERP</title>
        <meta name="description" content="This page doesn't exist." />
      </Helmet>
      <section className="py-32 px-6 text-center">
        <h1 className="text-4xl font-bold text-red-600">404 - Page Not Found</h1>
        <p className="mt-4 text-lg text-gray-600">Sorry, the page you’re looking for doesn’t exist.</p>
      </section>
    </Layout>
  );
};

export default NotFound;
